import React from "react";

export default function MyApp() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">MyApp</h2>
        </div>
      </div>
    </div>
  );
}
